import * as yup from 'yup';

import { fieldPoolIpV4YupValidation } from '@/shared/utils/validationSchema';

export const testRouterFormSchema = yup.object({
  ip: fieldPoolIpV4YupValidation,
  username: yup.string().required('El campo username es requerido'),
  password: yup
    .string()
    .required('El campo password es requerido'),
  puerto_api: yup.string().required('El campo puerto api es requerido'),
});
